module.exports = __webpack_public_path__ + "static/media/ZillaSlab-SemiBold.fb92db02.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/ZillaSlab-SemiBold.eot
// module id = 2989
// module chunks = 68